// @ts-nocheck
import addPanelDataConsts from '@/addPanelDataConsts';
import coreUtilsLib from 'coreUtilsLib';

const { blogAppPartNames } = coreUtilsLib;

export default {
  type: addPanelDataConsts.SECTIONS_TYPES.PRESET,
  hide: false,
  title: 'add_section_label_featuresposts',
  showSectionHeader: true,
  additionalBehaviours: {
    labelMode: addPanelDataConsts.LABEL_BEHAVIOUR.NONE,
    infoIcon: addPanelDataConsts.INFO_ICON_BEHAVIOUR.NONE,
    hoverImageAction: addPanelDataConsts.HOVER_IMAGE_ACTIONS.SCALE,
    iconEnabledForComps: {},
  },
  props: {
    image: 'blog/sections/featuredPostsSection.png',
    imageHover: null,
    items: [
      {
        id: 'Blog_Featured_Posts_1',
        structure: {
          type: 'Component',
          skin: 'wysiwyg.viewer.skins.AppPartSkin',
          layout: {
            width: 210,
            height: 180,
            x: -56,
            y: 14,
            scale: 1,
            rotationInDegrees: 0,
            fixedPosition: false,
          },
          componentType: 'wixapps.integration.components.AppPart',
          data: {
            type: 'AppPart',
            metaData: {
              isPreset: false,
              schemaVersion: '1.0',
              isHidden: false,
            },
            appInnerID: '12',
            appPartName: blogAppPartNames.FEATURED_POSTS,
            viewName: 'TickerMediaBottom',
            appLogicCustomizations: [],
            appLogicParams: {},
          },
          props: {
            type: 'AppPartProperties',
            metaData: { schemaVersion: '1.0' },
            direction: 'ltr',
          },
          style: {
            type: 'TopLevelStyle',
            id: 'blog_c7f57b50-8940-4ff1-83c6-6756d6f0a1f4_1',
            metaData: {
              isPreset: false,
              schemaVersion: '1.0',
              isHidden: false,
            },
            style: {
              groups: {},
              properties: { rd: '7px' },
              propertiesSource: { rd: 'value' },
            },
            componentClassName: '',
            pageId: '',
            compId: '',
            styleType: 'system',
            skin: 'wysiwyg.viewer.skins.AppPartSkin',
          },
          id: 'i74ul7du_2',
        },
        preset: { rect: { width: 162, height: 166, x: 0, y: 0 }, tags: null },
      },
      {
        id: 'Blog_Featured_Posts_2',
        structure: {
          type: 'Component',
          skin: 'wysiwyg.viewer.skins.AppPartSkin',
          layout: {
            width: 210,
            height: 147,
            x: 173,
            y: 14,
            scale: 1,
            rotationInDegrees: 0,
            fixedPosition: false,
          },
          componentType: 'wixapps.integration.components.AppPart',
          data: {
            type: 'AppPart',
            metaData: {
              isPreset: false,
              schemaVersion: '1.0',
              isHidden: false,
            },
            appInnerID: '12',
            appPartName: blogAppPartNames.FEATURED_POSTS,
            viewName: 'PostsList',
            appLogicCustomizations: [
              {
                type: 'AppPartCustomization',
                forType: 'Post',
                view: 'PostsList',
                key: 'comp.style',
                value: 'Body L',
                fieldId: 'title',
                format: '*',
              },
              {
                type: 'AppPartCustomization',
                forType: 'Post',
                view: 'PostsList',
                key: 'comp.hidden',
                value: 'true',
                fieldId: 'postSeparator',
                format: '*',
              },
              {
                type: 'AppPartCustomization',
                forType: 'Post',
                view: 'PostsList',
                key: 'comp.hidden',
                value: 'false',
                fieldId: 'date',
                format: '*',
              },
            ],
            appLogicParams: {},
          },
          props: {
            type: 'AppPartProperties',
            metaData: { schemaVersion: '1.0' },
            direction: 'ltr',
          },
          style: {
            type: 'TopLevelStyle',
            id: 'blog_c7f57b50-8940-4ff1-83c6-6756d6f0a1f4_1',
            metaData: {
              isPreset: false,
              schemaVersion: '1.0',
              isHidden: false,
            },
            style: {
              groups: {},
              properties: { rd: '7px' },
              propertiesSource: { rd: 'value' },
            },
            componentClassName: '',
            pageId: '',
            compId: '',
            styleType: 'system',
            skin: 'wysiwyg.viewer.skins.AppPartSkin',
          },
          id: 'i74ul7du_5',
        },
        preset: { rect: { width: 162, height: 138, x: 162, y: 0 }, tags: null },
      },
    ],
    compTypes: ['wixapps.integration.components.AppPart'],
  },
  help: { hide: false, text: 'add_section_info_text_featuresposts' },
};
